import type { Locale } from '@seek/melways-sites';
import { Box, Divider, Stack } from 'braid-design-system';
import { observer } from 'mobx-react';
import { type FC, Fragment } from 'react';

import type { IProspectEmailStore } from 'src/stores/JobApplicationStore/ProspectEmailStore';

import EmailItem from './EmailItem';

interface Props {
  prospectEmailStore: IProspectEmailStore;
  locale: Locale;
}

const ProspectEmailList: FC<Props> = ({
  prospectEmailStore,
  locale,
}: Props) => (
  <Stack space="large">
    {prospectEmailStore.emailList.map((email, index) => (
      <Fragment key={email.id}>
        <Box data-testid="email-item">
          <EmailItem email={email} locale={locale} />
        </Box>
        {index !== prospectEmailStore.emailList.length - 1 ? <Divider /> : null}
      </Fragment>
    ))}
  </Stack>
);
export default observer(ProspectEmailList);
